import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useEmendasParlamentaresState } from "../context/emendas-parlamentares-context";
import { useEmendasParlamentaresController } from "../context/emendas-parlamentares-controller";
import { EmendaParlamentarForm } from "./emenda-parlamentar-form";

export const EmendaParlamentarDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useEmendasParlamentaresController();
    const { dataResponse, showAddEdit } = useEmendasParlamentaresState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Emenda Parlamentar ${dataResponse?.id}`;
        return "Adicionar Emenda Parlamentar";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <EmendaParlamentarForm />
        </DefaultDrawer>
    );
};
